import { light } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NoLOIcon from "assets/images/v2/loan-officer-silhouette.svg";
import { useState } from "react";
import { LoanOfficerDetail } from "pages/application/applicationService";
import { formatPhoneNumber } from "utilities/string";
import "./loan-officer-card-v2.scss";

interface LoanOfficerCardV2Props {
  readonly loInfo: LoanOfficerDetail;
}

function LoanOfficerCardV2({ loInfo }: LoanOfficerCardV2Props) {
  const [imageLoadError, setImageLoadError] = useState(false);
  const phoneNumber = loInfo.phones?.[0]?.number || loInfo.phoneNumber;

  return (
    <div className="lo-card-v2">
      <p className="lo-card-v2__title">Your loan officer is ready to help</p>
      <p className="lo-card-v2__subtitle">You&#39;ve been invited to start your application</p>
      <hr className="lo-card-v2__divider" />
      <div className="lo-card-v2__info">
        <div className="lo-card-v2__avatar">
          {loInfo.photoImageUrl && !imageLoadError ? (
            <img
              src={loInfo.photoImageUrl}
              alt={loInfo.fullName}
              onError={() => setImageLoadError(true)}
            />
          ) : (
            <img src={NoLOIcon} alt="No loan officer" />
          )}
        </div>
        <span className="lo-card-v2__name">{loInfo.fullName}</span>
        {loInfo.jobTitle && <span className="lo-card-v2__job-title">{loInfo.jobTitle}</span>}
        {loInfo.nmlsLicenseNumber && (
          <span className="lo-card-v2__nmls">{`NMLS #${loInfo.nmlsLicenseNumber}`}</span>
        )}
      </div>
      <div className="lo-card-v2__contact">
        <span className="lo-card-v2__contact-label">CONTACT</span>
        {loInfo.workEmail && (
          <a href={`mailto:${loInfo.workEmail}`} className="lo-card-v2__contact-row lo-card-v2__contact-email">
            <span className="lo-card-v2__contact-icon">
              <FontAwesomeIcon icon={light("envelope-open")} />
            </span>
            <span>{loInfo.workEmail}</span>
          </a>
        )}
        {phoneNumber && (
          <a href={`tel:${phoneNumber}`} className="lo-card-v2__contact-row">
            <span className="lo-card-v2__contact-icon">
              <FontAwesomeIcon icon={light("phone")} />
            </span>
            <span>{formatPhoneNumber(phoneNumber)}</span>
          </a>
        )}
      </div>
    </div>
  );
}

export default LoanOfficerCardV2;
